// class DetailsModal extends HTMLElement {
//   constructor() {
//     super();
//     this.detailsContainer = this.querySelector('details');
//     this.summaryToggle = this.querySelector('summary');

//     this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
//     this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
//     this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

//     this.summaryToggle.setAttribute('role', 'button');
//   }

//   isOpen() {
//     return this.detailsContainer.hasAttribute('open');
//   }

//   onSummaryClick(event) {
//     event.preventDefault();
//     event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
//   }

//   onBodyClick(event) {
//     if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
//   }

//   open(event) {
//     this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
//     event.target.closest('details').setAttribute('open', true);
//     document.body.addEventListener('click', this.onBodyClickEvent);
//     document.body.classList.add('overflow-hidden');

//     trapFocus(
//       this.detailsContainer.querySelector('[tabindex="-1"]'),
//       this.detailsContainer.querySelector('input:not([type="hidden"])')
//     );
//   }

//   close(focusToggle = true) {
//     removeTrapFocus(focusToggle ? this.summaryToggle : null);
//     this.detailsContainer.removeAttribute('open');
//     document.body.removeEventListener('click', this.onBodyClickEvent);
//     document.body.classList.remove('overflow-hidden');
//   }
// }

// customElements.define('details-modal', DetailsModal);

class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    this.isOpen() ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);

    if (window.innerWidth <= 989) {
      // MOBILE EXECUTION:
      // 1. Swap body classes to match Globo's expected state
      document.body.classList.remove('overflow-hidden');
      document.body.classList.add('gl-search-open');

      // 2. Target the inner search input inside Dawn's modal
      const targetInput = this.querySelector('input[type="search"]') || this.querySelector('input[name="q"]');

      if (targetInput) {
        // Delay slightly so Globo's mutation observer detects <details open>
        setTimeout(() => {
          targetInput.focus();
          targetInput.click();
          targetInput.dispatchEvent(new Event('focusin', { bubbles: true }));
          targetInput.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));

          // 3. Reveal Globo popup once generated in DOM
          const filterPopup = document.getElementById('glFilter-search-popup');
          if (filterPopup) {
            filterPopup.style.display = 'block';
            filterPopup.setAttribute('aria-hidden', 'false');
            filterPopup.classList.add('gl-open', 'active', 'is-open');

            const popupInput = filterPopup.querySelector('input');
            if (popupInput) popupInput.focus();
          }

          if (window.globoFilter && typeof window.globoFilter.openSearch === 'function') {
            window.globoFilter.openSearch();
          }
        }, 50);
      }
    } else {
      // DESKTOP EXECUTION:
      document.body.classList.add('overflow-hidden');
      trapFocus(
        this.detailsContainer.querySelector('[tabindex="-1"]'),
        this.detailsContainer.querySelector('input:not([type="hidden"])')
      );
    }
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('gl-search-open');
  }
}

customElements.define('details-modal', DetailsModal);